import styled, { css, keyframes } from 'styled-components'
import { theme } from 'styles/mui-config'
import { MdClose } from "react-icons/md";

const containerCss = ({ isShown }) => {
  if (isShown) {
    return css`
    opacity: 1;
    pointer-events: visible;
    `
  }
}

export const Backdrop = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 110000;
    background-color: rgba(0, 0, 0, 0.5);
    opacity:0;
    transition: all 0.3s ease-in-out;
    pointer-events: none;
    transition: 0.3s;
    display:flex;
    justify-content:center;
    align-items:center;
    ${containerCss}
  `
///////////////////////////////////
const slideScale = keyframes`
  0%{
    transform:scale(.6);
    opacity:0;
  }
  100%{
    transform:scale(1);
    opacity:1;
  }
`

export const ModalContainer = styled.div`
  display: flex;
  width: 500px;
  max-width:90%;
  border-radius: 10px;
  min-height: 300px;
  flex-direction: column;
  align-items: center;
  transform:scale(1);
  transition: 0.3s;
  box-shadow: 0 0 5px rgb(194,194,194);
  background: #fafafa;
  animation: ${props => props.isShown ? css`${slideScale} 0.5s ease` : ''};
 `
/////////////////////////////////////////
export const Head = styled.div`
  padding:10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 8%;
  font-size: 15px;
  border-bottom: 2px solid ${theme.palette.primary.main};
  color: gray;
`

export const StyledMdClose = styled(MdClose)`
   fill: gray;
   cursor:pointer;
`

////////////////////////////////////////
export const Content = styled.div`
  direction: rtl;
  overflow-y: auto;
  width: 100%;
  padding: 20px;
`